import {Navigate, useLocation} from 'react-router'

export function RedirectWithParams({to}: {to: string}) {
    const location = useLocation()
    return <Navigate to={{...location, pathname: to}} />
}
